import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTokens } from '../../context/TokenContext';

const Sidebar = () => {
    const { logout } = useTokens();
    const navigate = useNavigate();
    const location = useLocation();
    const [activePage, setActivePage] = useState(location.pathname);
    const [openSubmenu, setOpenSubmenu] = useState(null);
    
    const menuItems = [
        {
            name: 'Dashboard',
            iconClass: 'bi bi-house-door-fill', 
            link: '/vendor/dashboard',
            submenu: [],
            count: 0,  
        },
        {
            name: 'Orders',
            iconClass: 'bi bi-box',  
            link: '/vendor/order/pending',
            submenu: [],
            count: 0,  
        },
        {
            name: 'Products',
            iconClass: 'bi bi-cup-straw',  
            link: '/vendor/product',
            submenu: [],
            count: 0,  
        },
        {
            name: 'Support',
            iconClass: 'bi bi-nut', 
            link: '/vendor/support',
            submenu: [],
            count: 0,  
        },
        {
            name: 'Notification',
            iconClass: 'bi bi-bell', 
            link: '/vendor/notifications',
            submenu: [],
            count: 0,  
        },
        {
            name: 'Payouts',
            iconClass: 'bi bi-wallet2',
            link: '/vendor/finance/total-revenue',
            submenu: [
                { name: 'Total Revenue', link: '/vendor/finance/total-revenue' },
                { name: 'Payout Requests', link: '/vendor/payout' },
                { name: 'Transaction Logs', link: '/vendor/finance/transactions' },
            ],
            count: 0,
        },
        {
            name: 'Profile',
            iconClass: 'bi bi-person', 
            link: '/vendor/profile',
            submenu: [],
            count: 0,  
        },
    ];
    
    useEffect(() => {
        setActivePage(location.pathname);
        menuItems.forEach((item) => {
            if (item.submenu && item.submenu.some(subitem => subitem.link === location.pathname)) {
                setOpenSubmenu(item.name); 
            }
        });
    }, [location.pathname]);

    const handleLogout = () => {
        logout('vendor', '/vendor/login');
    };

    const handleMenuClick = (link) => {
        setActivePage(link);
        setOpenSubmenu(true);
    };

    const handleSubMenuClick = (link) => {
        setActivePage(link);
        setOpenSubmenu(null);
    };

    const toggleSubMenu = (menuName) => {
        setOpenSubmenu(openSubmenu === menuName ? null : menuName);
    };

    const renderMenu = () => {
        return menuItems.map((item, index) => {
            const isActive = activePage === item.link; 
            const hasSubmenu = item.submenu.length > 0;
            const isSubmenuOpen = openSubmenu === item.name;  
    
            return (
                <li
                    key={index}
                    className={`nav-item ${hasSubmenu ? 'has-submenu' : ''} ${isActive || isSubmenuOpen ? 'active' : ''}`}
                >
                    <Link
                        to={item.link}
                        onClick={() => hasSubmenu ? toggleSubMenu(item.name) : handleMenuClick(item.link)}
                        className={`nav-link d-flex align-items-center gap-2 ${isActive ? 'bg-dark text-white' : 'text-dark'} hover:bg-light`}
                    >
                        <i className={item.iconClass}></i>
                        {item.name}
                        {item.count > 0 && (
                            <span className="badge bg-danger ms-auto">{item.count}</span> 
                        )}
                        {hasSubmenu && (
                            <i className={`bi ${isSubmenuOpen ? 'bi-dash' : 'bi-plus'} ms-auto`}></i>
                        )}
                    </Link>
                    {hasSubmenu && isSubmenuOpen && (
                        <ul className="submenu ms-3">
                            {item.submenu.map((subitem, subindex) => {
                                const isSubActive = activePage === subitem.link;  
                                return (
                                    <li key={subindex} className={`nav-item ${isSubActive ? 'active' : ''}`}>
                                        <Link
                                            to={subitem.link}
                                            onClick={() => handleSubMenuClick(subitem.link)}
                                            className={`nav-link d-flex align-items-center gap-2 ${isSubActive ? 'bg-dark text-white' : 'text-dark'} hover:bg-light`}
                                        >
                                            <i className="bi bi-caret-right-fill"></i>
                                            {subitem.name}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </li>
            );
        });
    }; 
    return (
        <div className="sidebar border border-right col-md-3 col-lg-2 bg-white">
            <div className='sticky-top' style={{'top': '40px'}}>
                <div className="offcanvas-md offcanvas-end bg-white" tabIndex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
                    <div className="offcanvas-header">
                        <h5 className="offcanvas-title" id="sidebarMenuLabel">Company Name</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" aria-label="Close"></button>
                    </div>
                    <div className="offcanvas-body d-md-flex flex-column pt-lg-3 overflow-y-auto">
                        <ul className="nav flex-column" onMouseOver={() => document.body.classList.add('sidebar-hover')}>
                            {renderMenu()}
                        </ul>
                        <hr className="my-3" />
                        <ul className="nav flex-column mb-auto">
                            <li className="nav-item">
                                <a onClick={handleLogout} href="#" className="nav-link d-flex align-items-center gap-2">
                                    <i className="bi bi-door-closed"></i>
                                    Sign out
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
